import { useNavigateToExercise } from '../practicalExerciseHooks';
import Raven from 'raven-js';
import { usePracticalExercisePortalId } from '../practicalExerciseQueries';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
const PracticalExerciseStartButton = ({
  contentId,
  lessonId,
  trackId,
  exerciseLocation,
  language,
  isExternal,
  onStartClick,
  use = 'primary',
  label
}) => {
  const {
    navigateToExercise,
    loading
  } = useNavigateToExercise({
    contentId,
    lessonId,
    trackId,
    language,
    exerciseLocation,
    onClick: onStartClick
  });
  const {
    getOrCreatePortal,
    portalIdLoading,
    isSimulationExercise
  } = usePracticalExercisePortalId(Number(contentId));
  const handleOnClick = () => {
    const callback = simulationPortalId => {
      if (isExternal) navigateToExercise(simulationPortalId).catch(Raven.captureException.bind(Raven));else if (onStartClick) onStartClick(simulationPortalId).catch(Raven.captureException.bind(Raven));
    };
    if (isSimulationExercise) {
      var _getOrCreatePortal;
      (_getOrCreatePortal = getOrCreatePortal()) === null || _getOrCreatePortal === void 0 || _getOrCreatePortal.then(response => {
        var _response$data;
        callback(response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 || (_response$data = _response$data.createPortal) === null || _response$data === void 0 ? void 0 : _response$data.portalId);
      }).catch(Raven.captureException.bind(Raven));
    } else callback();
  };
  return /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(LoadingButton, {
      "data-test-id": "practical-exercise-start-button",
      loading: loading || portalIdLoading,
      onClick: handleOnClick,
      use: use,
      children: label
    })
  });
};
export default PracticalExerciseStartButton;